
import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import insightsDetBanner from "../images/insights.jpeg"
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import $, { data } from "jquery"
import { database } from "../firebase";
import authorImg from "../images/author-sm.png"
import { Link } from 'react-router-dom';

export default class Insights extends Component {
  constructor(props) {
    super(props)
    this.state = {
      storyCategory: "",
      storyImage: null,
      storyTitle: "",
      storyDescription: "",
      storyCategories: [],
      title: ""
    }
  }
  async componentDidMount() {
    let url_path = window.location.href.split("=");
    let keyId = url_path[1].split('~')[0];
    let title = url_path[1].split('~')[2]
    this.setState({
      title: title
    })
    let storyCategoryList = []
    await database.ref("storyCategory").once('value', function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        if (ChildSnapshot.val().status == 'Active' && title === ChildSnapshot.val().mainCategory) {
          storyCategoryList.push({
            key: ChildSnapshot.key,
            name: ChildSnapshot.val().name
          });
        }
      });
    });
    this.setState({
      storyCategories: storyCategoryList
    })
    this.renderList(keyId);
    this.setState({
      storyCategory: this.props.location.state.storyCategory,
      createdAt: this.props.location.state.createdAt,
      storyImage: this.props.location.state.storyImage,
      storyTitle: this.props.location.state.storyTitle,
      storyDescription: this.props.location.state.storyDescription,
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fivanooo.com%2F'" + this.props.location.state.title + "'%2F",
      twitterLink: "https://twitter.com/intent/tweet/?text=The+Importance+of+Planning+Your+Career&amp;url=https%3A%2F%2Fivanooo.com%2F'" + this.props.location.state.title + "'%2F"
    })
  }
  async renderList(keyId) {
    let id = keyId;
    const ref = id ? "/stories/" + id : "stories";
    const userRef = database.ref(ref);

    const valueRef = id
    const snapshot = await userRef.once("value");
    const val = snapshot.val();
    this.setState({
      storyCategory: val.category,
      createdAt: val.createdAt,
      storyImage: val.imageUrl,
      storyTitle: val.title,
      storyDescription: val.description,
      //storyCategories : categories,
      fbLink: "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fivanooo.com%2F'" + val.title + "'%2F",
      twitterLink: "https://twitter.com/intent/tweet/?text=The+Importance+of+Planning+Your+Career&amp;url=https%3A%2F%2Fivanooo.com%2F'" + val.title + "'%2F"
    })
  }
  render() {

    return (

      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content">
          <div className="container">
            <section className="Insights-det-wrapper row">


              <div className="insights-det-body col-lg-8">

                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-center mb-0 bg-white">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item"><a href="/insightss">Stories</a></li>
                    <li className="breadcrumb-item active" aria-current="page">{this.state.storyTitle}</li>
                  </ol>
                </nav>
                <div className="col-md-12 m-auto px-0">
                  <h1 className='main-sub-head my-4'>{this.state.storyTitle}</h1>
                  <ul className="insights-box-list my-0">
                    {/* <li className="insights-list-inline-item">
                        <img src={authorImg} className="authorImg" alt="author" />Katen Doe
                      </li> */}
                    <li className="insights-list-inline-item">{this.state.storyCategory}</li>
                    <li className="insights-list-inline-item">{this.state.createdAt}</li>
                  </ul>
                </div>
                <div className='insightsDetBanner'>
                  <img src={this.state.storyImage} className='img-fluid insightsDetBannerImg'></img>
                  {/* <div className="tag-learning">
                    <i className="fa fa-tags"></i> {this.state.storyCategory}
                  </div> */}
                </div>
                <div className="col-md-12 m-auto">
                  {/* <h4 className='main-sub-head mb-4'>{this.state.storyTitle}</h4> */}
                  {/* <p>{ReactHtmlParser(this.state.storyDescription)}</p> */}
                  <p dangerouslySetInnerHTML={{ __html: this.state.storyDescription }} />

                </div>
                <div className='col-md-12'>
                  <hr></hr>
                </div>
                <div className="insights-det-social-share">
                  <ul className="social-share-ul">
                    <li className="social-share-list">
                      <a target="_blank" href={data.fbLink}><i className="fa fa-facebook-f"></i></a>
                    </li>
                    <li className="social-share-list">
                      <a target="_blank" href={data.twitterLink}><i className="fa fa-twitter"></i></a>
                    </li>
                    <li className="social-share-list">
                      <a target="_blank" href="#"><i className="fa fa-linkedin"></i></a>
                    </li>
                    <li className="social-share-list">
                      <a target="_blank" href="#"><i className="fa fa-pinterest"></i></a>
                    </li>
                    <li className="social-share-list">
                      <a target="_blank" href="#"><i className="fa fa-paper-plane"></i></a>
                    </li>
                    <li className="social-share-list">
                      <a target="_blank" href="#"><i className="fa fa-envelope"></i></a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className='col-lg-4 mt-4'>
                {/* <div className="form-head">Search</div>
                <div className='col-lg-12 col-md-6 form-group px-0' style={{ position: "relative" }}>
                  <input type="text" className="form-control" placeholder="Search..." />
                  <svg className="svg-icon search-icon" aria-hidden="true" role="img" focusable="false" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.80758 0C3.95121 0 0 3.95121 0 8.80758C0 13.6642 3.95121 17.6152 8.80758 17.6152C13.6642 17.6152 17.6152 13.6642 17.6152 8.80758C17.6152 3.95121 13.6642 0 8.80758 0ZM8.80758 15.9892C4.8477 15.9892 1.62602 12.7675 1.62602 8.80762C1.62602 4.84773 4.8477 1.62602 8.80758 1.62602C12.7675 1.62602 15.9891 4.8477 15.9891 8.80758C15.9891 12.7675 12.7675 15.9892 8.80758 15.9892Z" fill="currentColor"></path><path d="M19.762 18.6121L15.1007 13.9509C14.7831 13.6332 14.2687 13.6332 13.9511 13.9509C13.6335 14.2682 13.6335 14.7831 13.9511 15.1005L18.6124 19.7617C18.7712 19.9205 18.9791 19.9999 19.1872 19.9999C19.395 19.9999 19.6032 19.9205 19.762 19.7617C20.0796 19.4444 20.0796 18.9295 19.762 18.6121Z" fill="currentColor"></path></svg>
                </div> */}

                <div className='col-md-12 mt-5 categories-main'>
                  <div className="form-head">Categories</div>
                  <div className='col-md-12 p-0'>
                    {
                      this.state.storyCategories.map((x, y) =>
                        <div className='Categories-list'>
                          <i className="fa fa-angle-right"></i>
                          <Link to={'/insightss/id=' + this.state.title}>
                            {x.name}
                            <span className='Categories-list-count'></span>
                          </Link>
                        </div>
                      )}

                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <Footer></Footer>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/ivano/insights-details.jsx